export const createModal = () => {
  let $modal = null;
  let $content = null;

  const createModalElement = () => {
    const $modal = jQuery(`
      <div class="fixed inset-0 z-50 opacity-0 pointer-events-none transition-opacity duration-200 flex items-center justify-center">
        <div class="absolute inset-0 bg-black bg-opacity-50"></div>
        <div class="relative bg-white rounded-lg p-6 max-w-lg w-full mx-4 max-h-[90vh] overflow-y-auto transform transition-transform duration-200 translate-y-4 opacity-0">
          <button class="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
            </svg>
          </button>
          <div class="relative hidden"></div>
          <div class="flex items-center justify-center py-12 hidden">
            <svg class="animate-spin h-8 w-8 text-themePrimary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        </div>
      </div>
    `);

    jQuery("body").append($modal);

    $modal.find("button").on("click", close);
    $modal.find(".bg-black").on("click", close);

    return {
      $modal,
      $content: $modal.find(".relative.hidden").first(),
      $loader: $modal.find(".flex.items-center.justify-center"),
      $container: $modal.find(".bg-white"),
    };
  };

  const getElements = () => {
    if (!$modal) {
      const elements = createModalElement();
      $modal = elements.$modal;
      $content = elements.$content;
      return elements;
    }

    return {
      $modal,
      $content,
      $loader: $modal.find(".flex.items-center.justify-center"),
      $container: $modal.find(".bg-white"),
    };
  };

  const open = () => {
    const { $modal, $container } = getElements();
    $modal.removeClass("opacity-0 pointer-events-none");
    // Small timeout to trigger animation
    setTimeout(() => {
      $container.removeClass("opacity-0 translate-y-4");
    }, 10);
    jQuery("body").addClass("overflow-hidden");
  };

  const close = () => {
    const { $modal, $content, $container } = getElements();
    $container.addClass("opacity-0 translate-y-4");
    $modal.addClass("opacity-0 pointer-events-none");
    jQuery("body").removeClass("overflow-hidden");
    $content.html("");
  };

  const setContent = (html) => {
    const { $content, $loader } = getElements();
    $content.html(html);
    $loader.addClass("hidden");
    $content.removeClass("hidden");
  };

  const showLoader = () => {
    const { $content, $loader } = getElements();
    $content.addClass("hidden");
    $loader.removeClass("hidden");
  };

  return {
    open,
    close,
    setContent,
    showLoader,
    getElements,
  };
};
